/* eslint-disable prefer-arrow-callback */
/* eslint-disable wrap-iife */
G.Helpers = G.Helpers || {};

G.Helpers.bubbleGiftsMgr = (function () {
  // imports
  let saveStateMgr = null;
  const showBotOptinIconAfter = -1;
  const showBotOptinPopupAfter = -1;

  let bubbleGiftsData = null;

  function init(data) {
    saveStateMgr = G.saveState;

    bubbleGiftsData = data || bubbleGiftsData;
  }

  function getSaveData() {
    if (!saveStateMgr.data.bubbleGifts) {
      saveStateMgr.data.bubbleGifts = [];
    }
    return saveStateMgr.data.bubbleGifts;
  }

  function markBubbleAsOpen(levelNumber) {
    getSaveData().push(levelNumber);
    saveStateMgr.save();
  }

  function getBubble(levelNumber) {
    return bubbleGiftsData.find(function (bubble) {
      return bubble.levelNumber === levelNumber;
    });
  }

  function getAllBubblesLevels() {
    return bubbleGiftsData.map(function (bubble) {
      return bubble.levelNumber;
    });
  }

  function getBubbleGift(levelNumber) {
    return G.Utils.clone(getBubble(levelNumber).gift);
  }

  function isBubbleOpened(levelNumber) {
    return getSaveData().indexOf(levelNumber) >= 0;
  }

  function getUnopenedBubblesLevels() {
    return bubbleGiftsData.filter(function (bubble) {
      return !isBubbleOpened(bubble.levelNumber);
    }).map(function (bubble) {
      return bubble.levelNumber;
    });
  }

  function getNumOfOpenedChests() {
    return getAllBubblesLevels().length - getUnopenedBubblesLevels().length;
  }

  function iconAndPopupIn(iconIn, popupIn) {
    this.showBotOptinIconAfter = iconIn;
    this.showBotOptinPopupAfter = popupIn;
  }

  return {
    init,
    getUnopenedBubblesLevels,
    markBubbleAsOpen,
    getBubbleGift,
    isBubbleOpened,
    getAllBubblesLevels,
    getNumOfOpenedChests,
    iconAndPopupIn,
    showBotOptinIconAfter,
    showBotOptinPopupAfter,
  };
})();
